import { LayoutType, withLayout } from 'hocs/with-layout';
import { SelectCategories } from './onboarding-select-categories';

const WrappedSelectCategories = withLayout(
  LayoutType.WithOldNavOnly,
  SelectCategories,
);

export { WrappedSelectCategories as SelectCategories };
